import React from 'react';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from '../contexts/AuthContext';
import { LocationProvider } from '../contexts/LocationContext';
import { EmployeeProvider } from '../contexts/EmployeeContext';
import { CartProvider } from '../features/cart/context/CartContext';
import { LanguageProviderWithRoutes } from '../i18n/useTranslation';

interface AppProvidersProps {
  children: React.ReactNode;
}

/**
 * AppProviders Component
 * 
 * Wraps the application with all necessary context providers.
 * Providers are ordered from outer to inner based on dependencies.
 */
export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <QueryProvider>
      <AuthProvider>
        <LocationProvider>
          <EmployeeProvider>
              <CartProvider>
                {children}
              </CartProvider>
            </EmployeeProvider>
        </LocationProvider>
      </AuthProvider>
    </QueryProvider>
  );
};

/**
 * LanguageProviderWrapper
 * 
 * Must be inside Router to use useLocation hook.
 * Wraps routes with language provider that supports route-aware language switching.
 */
export const LanguageProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <LanguageProviderWithRoutes>
      {children}
    </LanguageProviderWithRoutes>
  );
};

